"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkReminder = exports.isReminder = exports.ReminderRepeatType = void 0;
const Check_1 = require("../check/Check");
var ReminderRepeatType;
(function (ReminderRepeatType) {
    ReminderRepeatType["HOURLY"] = "HOURLY";
    ReminderRepeatType["DAILY"] = "DAILY";
    ReminderRepeatType["WEEKLY"] = "WEEKLY";
    ReminderRepeatType["MONTHLY"] = "MONTHLY";
    ReminderRepeatType["YEARLY"] = "YEARLY";
})(ReminderRepeatType = exports.ReminderRepeatType || (exports.ReminderRepeatType = {}));
function isReminder(object) {
    return checkReminder(object).fulfilled;
}
exports.isReminder = isReminder;
function checkReminder(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return (0, Check_1.check)(object, (0, Check_1.hasString)("id"), (0, Check_1.hasString)("resourceId"), (0, Check_1.hasChoice)("resourceType", ["task"]), (0, Check_1.hasChoice)("repeatType", Object.values(ReminderRepeatType)).optional(), (0, Check_1.hasString)("scheduledTaskId").optional(), (0, Check_1.hasNumber)("creationTimestamp"), (0, Check_1.hasNumber)("timestamp")).withOptions(options).explain();
}
exports.checkReminder = checkReminder;
//# sourceMappingURL=Reminder.js.map